export const MAX_CUSTOM_PAGES = 10;
const BYTES_PER_MEGABYTE = 1024 * 1024;
export const PDF_MAX_SIZE_BYTES = 10 * BYTES_PER_MEGABYTE;
export const DEFAULT_PAGE_TITLE = 'Custom page';
export const DEFAULT_DISPLAY_SCOPE = 'proposalOnly';
export const createBlankVideoPage = (id, displayOrder)=>({
        id,
        pageTitle: DEFAULT_PAGE_TITLE,
        displayOrder,
        displayScope: DEFAULT_DISPLAY_SCOPE,
        type: 'video',
        video: {
            videoUrl: ''
        }
    });
export const createBlankTextPage = (id, displayOrder, textId)=>({
        id,
        pageTitle: DEFAULT_PAGE_TITLE,
        displayOrder,
        displayScope: DEFAULT_DISPLAY_SCOPE,
        type: 'text',
        text: {
            textId
        }
    });
export const createBlankPdfPage = (id, displayOrder, pdfName, pdfFileName)=>({
        id,
        pageTitle: DEFAULT_PAGE_TITLE,
        displayOrder,
        displayScope: DEFAULT_DISPLAY_SCOPE,
        type: 'pdf',
        pdf: {
            pdfName,
            pdfFileName
        }
    });
export const createEmptyPdfPage = (id, displayOrder)=>createBlankPdfPage(id, displayOrder, '', '');
